import { useEffect } from 'react';

/**
 * Signals to the prerender service that the page content is ready.
 * Call this hook AFTER your main data has loaded.
 * 
 * Usage: usePrerenderReady(!!course)  // signals when course data is loaded
 */
export function usePrerenderReady(isReady) {
  useEffect(() => {
    if (isReady && typeof window !== 'undefined') {
      window.prerenderReady = true;
    }
  }, [isReady]);
}
